export const UPDATE_REFERRER_SETTINGS = 'src/ReferrerSettings/UPDATE_REFERRER_SETTINGS';
export const UPDATE_REFERRER_SETTINGS_SUCCESS = 'src/ReferrerSettings/UPDATE_REFERRER_SETTINGS_SUCCESS';
export const UPDATE_REFERRER_SETTINGS_ERROR = 'src/ReferrerSettings/UPDATE_REFERRER_SETTINGS_ERROR';

export const FETCH_REFERRER_SETTINGS = 'src/ReferrerSettings/FETCH_REFERRER_SETTINGS';
export const FETCH_REFERRER_SETTINGS_SUCCESS = 'src/ReferrerSettings/FETCH_REFERRER_SETTINGS_SUCCESS';
export const FETCH_REFERRER_SETTINGS_ERROR = 'src/ReferrerSettings/FETCH_REFERRER_SETTINGS_ERROR';

export const RESET_REFERRER_SETTINGS_SAVED = 'src/ReferrerSettings/RESET_REFERRER_SETTINGS_SAVED';
